import { cx } from "cva";
import { LandingPageV2Hero } from "~/components/LandingPageV2/schemas";
import { CTALink } from "~/landing-pages/components/CTA/CTALink/CTALink";
import { ctaContainerStyle } from "~/landing-pages/shared-landing-page-styles";
import { getButtonStyles } from "~/ui-library/shared-styles/shared-button-styles";

export type LandingPageCTAsProps = Pick<
  LandingPageV2Hero,
  "includeCtas" | "primaryCta" | "secondaryCta" | "ctaAlignment"
> & {
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
};

export const LandingPageCTAs: React.FC<LandingPageCTAsProps> = ({
  includeCtas,
  primaryCta,
  secondaryCta,
  ctaAlignment,
  onPrimaryClick,
  onSecondaryClick,
}) => {
  /* istanbul ignore next */
  if (!includeCtas || (!primaryCta && !secondaryCta)) {
    return null;
  }

  return (
    <div className={ctaContainerStyle({ ctaAlignment })}>
      {primaryCta && (
        <CTALink
          href={primaryCta.url}
          onClick={onPrimaryClick}
          className={cx(
            getButtonStyles({ variant: "primary" }),
            "flex items-center justify-center",
            "w-full md:w-fit md:min-w-[125px]"
          )}
        >
          {primaryCta.title}
        </CTALink>
      )}
      {secondaryCta && (
        <CTALink
          href={secondaryCta.url}
          onClick={onSecondaryClick}
          className={cx(
            getButtonStyles({ variant: "subtle" }),
            "flex items-center justify-center",
            "w-full md:w-fit md:min-w-[125px]"
          )}
        >
          {secondaryCta.title}
        </CTALink>
      )}
    </div>
  );
};
